module.exports = __webpack_public_path__ + "static/matic-11bee2170b72d5c8e48316015627bb98.png";